import WorkTemplate from '~templates/work'
export default WorkTemplate